import { useEffect, useState } from 'react';
import type { MainLoaderData } from '@/root';

export const GTMScript = ({ env }: { env?: MainLoaderData['ENV'] }) => {
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  useEffect(() => {
    if (!env || isScriptLoaded) {
      return;
    }
    if (typeof window !== 'undefined') {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.setAttributeNode(d.createAttribute('data-ot-ignore'));
        j.setAttribute('class', 'optanon-category-C0001');
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode?.insertBefore(j, f);
        setScriptLoaded(true);
      })(window, document, 'script' as const, 'dataLayer' as const, env.GTM_ID);
    }
  }, [env, isScriptLoaded]);

  return null;
};
